import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';
Vue.use(VueScrollTo, {
  "duration": 1200,
  "easing": "cubic-bezier(0.85, 0, 0.15, 1)",
  "offset": -50
});
export default function (ctx, inject) {
  inject('scrollTo', VueScrollTo.scrollTo);
}